<template>
<div class="direction container tw-flex tw-flex-col tw-items-center type-client tw-px-5 relative">
    <title-section
    title="Consigue una oferta por tu vivienda"
    subtitle="Seguidamente te pediremos información sobre tu casa para efectuar una valoración determinada."></title-section>
    <p class="direction-text tw-mt-16 tw-text-left">Dirección</p>

    <div class="autocomplete-maps tw-flex tw-flex-col tw-relative tw-my-4">
        <input type="text" placeholder="Introduce la dirección de tu casa" v-model="direction"/>
    </div>

    <p class="direction-text tw-text-left">Escribe tu dirección con el mayor detalle posible (calle, número, ciudad y código postal)</p>
    <div class="fixed-button-mobile tw-mt-8">
    <button
        @click="goNextStep"
        class="btn btn-primary fixed-button btn-steps tw-flex tw-items-center tw-justify-center"
        :class="{ active: direction }"
    >
        Siguiente
    </button>
    </div>
</div>
</template>

<script>
import { initiateChips } from "../../utils";
import { mapMutations, mapGetters } from "vuex";
export default {
data: () => ({
    direction: ""
}),
computed: {
    ...mapGetters({
        wizard: 'getWizard'
    })
},
methods: {
    ...mapMutations(["selectDirection"]),
    goNextStep() {
        if(this.direction){
            this.selectDirection(this.direction);
            this.$router.push({ name: "typeApartment" });
        }
    },
},
mounted() {
    initiateChips();
},
created() {
    if(this.$cookies.get("directionValue") && this.direction === ""){
        this.direction = this.$cookies.get("directionValue");
    }
}
};
</script>

<style lang="scss">
@import "../../../sass/variables";
.direction {
    .autocomplete-maps {
        @media(max-width: $lg){
            width: 100%;
        }
    }
    .autocomplete-maps {
    font-size: 16px;
   
    input {
        background-color: $color-white;
        height: 50px;
        width: 569px;
        border-radius: 25px;
        border: solid 0.5px $border-chip;
        padding: 13px 13px;
        font-family: $font-nimbus !important;
        @media(max-width: $lg){
            width: 100%;
        }
    }
    button {
        @media(min-width: $lg){
            position: absolute;
            right:0;
        }
        @media(max-width: $lg){
            width: 162px;
            margin-top: 1rem;
        }
    }
}
.btn-primary {
      width: 273px;
      margin-left: auto;
      margin-right: auto;
      height: 48px;
      border-radius: 6px;
      transition: all 0.4s ease-in-out;
      background-color: $color-grey-hover;
  
      &.active {
        background-color: $primary;
      }
    }
    .btn-steps {
        @media(max-width: $lg){
            left: 3%;
        }
    }
    .direction-text {
        @media(max-width: $lg){
            width: 95%;
        }
    }
}
.type-client {
.mdc-chip {
    width: 319.4px;
    height: 58.7px;
    @media(max-width: $lg){
    width: 100%;
    }
}
}
</style>
